export const isErrorWithMessage = (err: unknown, statusCode: string): boolean => {
  return (
    typeof err === 'object' &&
    err !== null &&
    'message' in err &&
    (err as { message: string }).message.endsWith(statusCode)
  );
};
